module.exports = __webpack_public_path__ + "static/img/imgadd.415f6ad.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/imgadd.jpg
// module id = yvoj
// module chunks = 57